import { createContext } from 'react';

export interface FormContextProps<T = any> {
  stepData: T;
  stepValid: Record<`step${number}`, boolean>;
  setStepData: React.Dispatch<React.SetStateAction<any>>;
}

export function createPageWizardContext<T = any>() {
  return createContext<FormContextProps<T>>({
    stepData: {} as T,
    stepValid: {},
    setStepData: () => {},
  });
}
